import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import MuiXLicense from "./api/config";
import Notification from "./common/notificationComponent";
import Routing from "./routing/routeComponent";
import theme from "./theme/theme";


function App() {
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Routing />
			<Notification />
			<MuiXLicense />
		</ThemeProvider>
	);
}

export default App;
